import React from "react";

interface AddIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const UserIcon: React.FC<AddIconProps> = ({ size = 32, color = '#003366', className, onClick }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.66406 26.6667V25.3333C6.66406 20.1787 10.8427 16 15.9974 16C21.1521 16 25.3307 20.1787 25.3307 25.3333V26.6667" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.9974 15.9993C18.9429 15.9993 21.3307 13.6114 21.3307 10.666C21.3307 7.72045 18.9429 5.33264 15.9974 5.33264C13.0519 5.33264 10.6641 7.72045 10.6641 10.666C10.6641 13.6114 13.0519 15.9993 15.9974 15.9993Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>


);

export default UserIcon;